import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limit'
})
export class LimitPipe implements PipeTransform {

  transform(value: number, limit : number = 9): unknown {
    return value < limit ? value : limit + "+";
  }

}
